---
title: Delay
description: "A delay device: a time or a note value, a feedback, a tone and a mix, a panel that draws the echoes with a handle, a Web Audio engine and tools for agents."
component: true
base: base
---

<ComponentPreview styleName="base-nova" name="block-delay" />

Repeats the sound. The echoes fade by the feedback, each darker than the one before. It is a [device](/docs/devices): a state, a panel, an engine and tools, each its own file.

## Installation

<Install name="delay" kind="device" />

## Controls

<DeviceControls device="delay">
<Control id="timeMs">The time between the echoes. Drag the handle on the first echo across to set it.</Control>
<Control id="sync">Takes the time from a note value and the tempo of the host instead of milliseconds. See [Tempo sync](/docs/devices#tempo-sync).</Control>
<Control id="division">The note value of the time, from 1/32 to a whole note, with triplets and dotted notes.</Control>
<Control id="feedback">How much of the output goes back in. Drag the handle on the first echo up to raise it.</Control>
<Control id="toneHz">Closes the highs of each repeat.</Control>
<Control id="mix">The balance of the echoes and the dry signal.</Control>
</DeviceControls>

## Panel

The panel draws the echoes the state makes, one line each, fainter as they fade. `delayTaps(state, windowMs)` returns them. With Sync on, the handle lands on the nearest note value and the Time control is drawn off. With Sync off, the note list is.

<DeviceUsage name="delay" />

## Engine

Create it, connect it and update it as for any device: see [The engine](/docs/devices#the-engine).

The repeats go round a low-pass filter, so each is darker than the one before. A change of time glides slowly, so the echo bends like a tape instead of clicking, and the feedback stops short of 95 % so it cannot run away. A note longer than the delay can hold (two seconds) is held to that. The `1/8d` the block starts on is a dotted eighth at the loop's 100 BPM, 450 ms.
